import React from 'react';

import Grid from '@material-ui/core/Grid';

import MemberReferralsList from '../referrals/MemberReferralsList';
import MemberQuotesList from '../quotes/MemberQuotesList';
import MemberBookingList from '../bookings/MemberBookingList';
import Typography from '@material-ui/core/Typography'
import MemberTimesheetsContent from '../timesheets/MemberTimesheetsContent';
import MemberMiniMenu from '../menus/MemberMiniMenu';

const MemberPipelineContent = () => {
    return (
        <div>
            <Grid container spacing={2}>
                <Grid container item direction="column" xs={12} lg={3}>
                    <Typography variant="h6" color="initial">Referrals</Typography>
                    <MemberReferralsList />
                </Grid>
                <Grid container item direction="column" xs={12} lg={3}>
                    <Typography variant="h6" color="initial">Quotes</Typography>
                    <MemberQuotesList />
                </Grid>
                <Grid container item direction="column" xs={12} lg={3}>
                    <Typography variant="h6" color="initial">Bookings</Typography>
                    <MemberBookingList />
                </Grid>
                <Grid container item direction="column" xs={12} lg={3}>
                    <Typography variant="h6" color="initial">Invoices</Typography>
                    <MemberTimesheetsContent layout="column" />
                </Grid>
            </Grid>
        </div>
    );
}

const MemberPipelinePage = () => {
    return <MemberMiniMenu>
        <MemberPipelineContent />
    </MemberMiniMenu>
};

export default MemberPipelinePage;